import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import { ObjectElement } from '@swagger-api/apidom-core';
class MediaTypeExamples extends ObjectElement {
  constructor(content, meta, attributes) {
    super(content, meta, attributes);
    this.classes.push(MediaTypeExamples.primaryClass);
    this.classes.push('examples');
  }
}
_defineProperty(MediaTypeExamples, "primaryClass", 'media-type-examples');
export default MediaTypeExamples;